import React, { Fragment } from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  label: {
    width: "35%",
    fontWeight: "100",
  },
  inputBox: {
    width: "50%",
  },
  subHeading: {
    paddingBottom: 20,
    color: "blue",
  },
}));
function ViewDetailedProfile({ userProfile }) {
  const classes = useStyles();

  const personalInfo = () => {
    return (
      <Fragment>
        <div id="top" style={{ display: "flex", flexDirection: "row" }}>
          <div
            id="left"
            className="col-md-6"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className="form-group">
              <label className={classes.label}>Teaching/Non-teaching:</label>
              {userProfile.is_technical ? "Teaching" : "Non-Teaching" || "-"}
            </div>
            <div className="form-group">
              <label className={classes.label}>College ID:</label>
              {userProfile.faculty_id}
            </div>
            <div className="form-group">
              <label className={classes.label}>Phone:</label>
              {userProfile.mobile_number}
            </div>
            <div className="form-group">
              <label className={classes.label}>First Name:</label>
              {userProfile.full_name.first_name}
            </div>
            <div className="form-group">
              <label className={classes.label}>Middle Name:</label>
              {userProfile.full_name.middle_name || "-"}
            </div>
            <div className="form-group">
              <label className={classes.label}>Last Name:</label>
              {userProfile.full_name.last_name || "-"}
            </div>
            <div className="form-group">
              <label className={classes.label}>Gender:</label>
              {userProfile.gender || "-"}
            </div>
            <div className="form-group">
              <label className={classes.label}>Father's Name:</label>
              {userProfile.father_name || "-"}
            </div>
            <div className="form-group">
              <label className={classes.label}>Mother's Name:</label>
              {userProfile.mother_name || "-"}
            </div>
            <div className="form-group">
              <label className={classes.label}>Department:</label>
              {userProfile.department || "-"}
            </div>
            <div className="form-group">
              <label className={classes.label}>Reporting Manager:</label>
              {userProfile.reference_faculty}
            </div>
          </div>
          <div
            id="right"
            className="col-md-6"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className="form-group">
              <label className={classes.label}>Super admin:</label>
              {userProfile.isSuperAdmin ? "Yes" : "No" || "-"}
            </div>
            <div className="form-group">
              <label className={classes.label}>Email Id:</label>
              {userProfile.email_id}
            </div>
            <div className="form-group">
              <label className={classes.label}>Date of birth:</label>
              {userProfile.date_of_birth
                ? new Date(userProfile.date_of_birth)
                    ?.toISOString()
                    .substring(0, 10)
                : "-"}
            </div>
            <div className="form-group">
              <label className={classes.label}>Joining Date:</label>
              {userProfile.date_of_joining &&
                new Date(userProfile.date_of_joining)
                  ?.toISOString()
                  .substring(0, 10)}
            </div>
            <div className="form-group">
              <label className={classes.label}>PAN:</label>
              {userProfile.pan_number || "-"}
            </div>
            <div className="form-group">
              <label className={classes.label}>Aadhar Number:</label>
              {userProfile.aadhar_number || "-"}
            </div>
            <div className="form-group">
              <label className={classes.label}>Spouse Name:</label>
              {userProfile.spouse_name || "-"}
            </div>
            <div className="form-group">
              <label className={classes.label}>Residential Address:</label>
              {userProfile.residential_address || "-"}
            </div>
            <div className="form-group">
              <label className={classes.label}>Subject Specialization:</label>
              {userProfile.subject_specialization || "-"}
            </div>
          </div>
        </div>
        <hr className="section-hr" />
        <div id="middle" style={{ display: "flex", flexDirection: "row" }}>
          <div
            id="left"
            className="col-md-6"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className="form-group">
              <label className={classes.label}>PhD documents:</label>
              {userProfile.phd_documents.length > 0 &&
              userProfile.phd_documents[0] !== ""
                ? userProfile.phd_documents.map((url, idx) => {
                    return (
                      <li key={idx}>
                        <a
                          href={url}
                          rel="noopener noreferrer"
                          target="_blank"
                        >{`Phd Document ${idx + 1}`}</a>
                      </li>
                    );
                  })
                : "No Documents uploaded"}
            </div>
            {/* <div className="form-group">
              <label className={classes.label}>Super admin:</label>
              {userProfile.isSuperAdmin ? "Yes" : "No" || "-"}
            </div> */}
          </div>
          <div
            id="right"
            className="col-md-6"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className="form-group">
              <label className={classes.label}>Other documents:</label>
              {userProfile.other_documents.length > 0 &&
              userProfile.other_documents[0] !== ""
                ? userProfile.other_documents.map((url, idx) => {
                    return (
                      <li key={idx}>
                        <a
                          href={url}
                          rel="noopener noreferrer"
                          target="_blank"
                        >{`Other Document ${idx + 1}`}</a>
                      </li>
                    );
                  })
                : "No Documents uploaded"}
            </div>
            {/* <div className="form-group">
              <label className={classes.label}>Super admin:</label>
              {userProfile.isSuperAdmin ? "Yes" : "No" || "-"}
            </div> */}
          </div>
        </div>
      </Fragment>
    );
  };
  return (
    <Fragment>
      <div
        className="popup-content"
        style={{ padding: "0", overflowX: "scroll", maxHeight: "70vh" }}
      >
        <div class="form-group">{personalInfo()}</div>
      </div>
    </Fragment>
  );
}

export default ViewDetailedProfile;
